<template id="regForm">
<section class="registrationColumnLogin">
  <div class="container">
    <div class="row">
      <!-- managers -->
      <div v-if="isactive==0" class="col-md-12 col-sm-12 ">
        <div class="col-md-12 col-sm-12 ">
          <div class="redBarOuter acoountRed">
            <div class="redbar flex">
              <div class="icon iconfont"><i class="fa fa-ban"></i></div>
              <div class="warning-text">
                <p v-html="res.disabled"></p>
              </div>
            </div>
          </div>
          <div class="datacards">
            <template v-for="(manager, midx) in reseller.managers">
              <manager :idx="midx" :manager="manager" :common_res="common_res" :res="res" v-bind:key="manager.managerid"/>
            </template>
            <!--div-- class="datacard">
              <div class="datacard-avartar">
                <img src="images/contents/manager/leslie-s.jpg">
              </div>
              <div class="datacard-data">
                <h3 class="datacard-name">John Smith</h3>
                <p class="datacard-title">Relationship Manager</p>
                <div class="datacard-desc">Your Relationship Manager is your main contact at Sampson Store and is ready to help you grow your business. They provide guidance and support tailored to your needs. And if you have any suggestions about how we can improve our services, they will be more than happy to hear from you.</div>
                <div class="datacard-divider"></div>
                <div class="datacard-infoblocks">
                  <div class="datacard-infoblock">
                    <span class="datacard-caption">Direct</span>
                    <p class="datacard-value">3727-5555</p>
                  </div>
                  <div class="datacard-infoblock">
                    <span class="datacard-caption">WhatsApp</span>
                    <a class="datacard-value" href="https://wa.me/85212345678">1234-5678</a>
                  </div>
                  <div class="datacard-infoblock full">
                    <span class="datacard-caption">Email</span>
                    <a href="mailto:johnsmith@sampsonstore.com" class="datacard-value">johnsmith@sampsonstore.com</a>
                  </div>
                </div>

              </div>
            </!--div-->
            <!--div-- class="datacard">
              <div class="datacard-avartar">
                <img src="images/contents/manager/keung-s.jpg">
              </div>
              <div class="datacard-data">
                <h3 class="datacard-name">Tom Sawyer</h3>
                <p class="datacard-title">Account Manager</p>
                <div class="datacard-desc">Your Account Manager is also your dedicated point of contact, who can assist you with your business operation. They can help you place an order and order promotion materials, ensuring all your day-to-day needs are fully met.</div>
                <div class="datacard-divider"></div>
                <div class="datacard-infoblocks">
                  <div class="datacard-infoblock">
                    <span class="datacard-caption">Direct</span>
                    <p class="datacard-value">3727-5678</p>
                  </div>
                  <div class="datacard-infoblock">
                    <span class="datacard-caption">WhatsApp</span>
                    <a class="datacard-value" href="https://wa.me/85298765432">9876-5432</a>
                  </div>
                  <div class="datacard-infoblock full">
                    <span class="datacard-caption">Email</span>
                    <a href="mailto:tomsawyer@sampsonstore.com" class="datacard-value">tomsawyer@sampsonstore.com</a>
                  </div>
                </div>
              </div>
            </!--div-->
          </div>
        </div>
      </div>
      <!-- managers -->
      <div class="col-md-6 col-sm-10 col-md-offset-3 col-sm-offset-1 col-xs-12">
        <div class="col-md-12 col-sm-12" id="a_email">
          <div class="inputBlock">
            <label for="">{{res.email}}</label>
            <div v-if="error.email" v-on:click="removeErr($event,'email')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.email}}</p>
            </div>
            <div class="inputOuter">
              <!--input type="text" class="form-control inputText" placeholder="sam@abc.com"-->
              <input v-on:keyup.27="tryCustomers($event)" v-on:keyup.13="chkReg()" type="email" v-on:focus="removeErr($event,'email')" :class="error.email?'form-control errorMessage inputText':'form-control inputText'" placeholder="" v-model="reseller.email">
              <span><img src="@/images/mailicon.png" alt=""></span>
            </div>
            <div class="inputOuter" v-if="customers != null && customers.length > 0">
              <select style="padding:0 20px 0 85px" v-on:change="setEmail($event)" class="form-control inputText" placeholder="">
                <option value="">Please select customer</option>
                <option v-for="(customer, idx) in customers" :value="customer.email">{{customer.custcode}} - {{customer.name}}</option>
              </select>
              <span><img src="@/images/mailicon.png" alt=""></span>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" id="a_password">
          <div class="inputBlock">
            <label for="">{{res.password}}</label>
            <div v-if="error.password" v-on:click="removeErr($event,'password')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.password}}</p>
            </div>
            <div class="inputOuter lock">
              <input v-on:keyup.13="chkReg()" type="password" v-on:focus="removeErr($event,'password')" :class="error.password?'form-control errorMessage inputText':'form-control inputText'" placeholder="" v-model="reseller.password">
              <span><img src="@/images/lockicon.png" alt=""></span></div>
          </div>
        </div>

        <div class="col-xs-12">
          <label class="checkBoxOuter">
            <input type="checkbox" name="auto_login" v-on:click="chkAuto()" :checked="reseller.auto_login">
            <span>{{res.keep}}</span>
          </label>
          <div class="forgot">
            <ul>
              <li><a :href="pageRoot+'/resetpwd.html'">{{res.resetpwd}}</a><span>|</span></li>
              <li><a :href="pageRoot + '/reg.html'">{{res.reg}}</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="centerbutton">
            <div id="recaptcha" class="g-recaptcha"></div>
            <input v-on:click="chkReg()" type="submit" :class="(submitted?'submitted ':'')+'form-control submitButton'" :value="res.submit">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>

import Vue from 'vue'
var VueCookie = require('vue-cookie');
import utils from './Utils.vue'
import manager from './Manager.vue'

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'regLogin',
  props:['name', 'clients', 'firstamts', 'countries', 'common_res', 'res'],
  data () {
    return {
      reseller:{"auto_login":false},
      submitted:false,
      customers:null,
      isactive:1,
      error:{}
    }
  },
  components: {
    manager
  },
  methods: {
    setEmail: function(evt) {
      this.reseller.email = evt.target.value;
      this.customers = null;
    },
    tryCustomers: function(evt) {
      var self = this;
      if (self.reseller.email == null || self.reseller.email == '') {
        self.customers = [];
        Vue.http.get(utils.getServerPath()+'/reseller/customers.is').then(response => {
          var list = response.data.customers;
          if (list.length > 0) {
            //utils.cleanCart();
          }
          for (var i=0;i<list.length;i++) {
            self.customers.push(list[i]);
          }
        });
        //self.customers.push({"custcode":"ABC", "email":"test@test.com", "name":"company abc"});
      }
    },
    initReCaptcha: function() {
      var self = this;
      setTimeout(function() {
          if(typeof grecaptcha === 'undefined') {
              self.initReCaptcha();
          }
          else {
              grecaptcha.render('recaptcha', {
                  sitekey: '6LfX_28UAAAAAKVy8qQjPz_yYFLwrOHeYdX_bwMk',
                  size: 'invisible',
                  //badge: 'inline',
                  callback: self.doLogin
              });
          }
      }, 100);
    },
    chkAuto: function() {
      this.reseller.auto_login = !this.reseller.auto_login;
    },
    validate: function() {
      if (this.submitted) return;
      grecaptcha.execute();
    },
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    chkReg:function() {
      var isok = true;
      var goto = null;
      var self = this;
      if (!this.chk('email', /^.{1,}$/, this.res.email_err)) {
        isok = false;
        if (!goto) goto = 'email';
      } else if (!this.chk('email', /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i, this.res.contact_email_invalid)) {
        isok = false;
        if (!goto) goto = 'email';
      }
      if (!this.chk('password', /^.{1,}$/, this.res.password_err)) {
        if (!goto) goto = 'password';
        isok = false;
      }
      if (isok) {
        this.validate();
      } else {
        if (goto) {
          $("#a_"+goto)[0].scrollIntoView();
          goto = null;
        }
        var fd = utils.saveJSONToForm(this.reseller);
      }
      this.$forceUpdate();
    },
    doLogin:function(response) {
      if (this.submitted) return;
      this.submitted = true;
      var self = this;
      if (response != null) {
        this.reseller['g-recaptcha-response'] = response;
      }
      if (1==1) {
        // restore Cart before login
        utils.restoreCart();
        //utils.cleanCart();
        self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
        self.isactive = 1;
        utils.saveData({
            url: utils.getServerPath()+'/reseller/userauth.is',
            mode: 'insert',
            repos: 'db',
            value: utils.saveJSONToForm(this.reseller),
            name: 'reg.reseller'
          }, function(success, data) {
console.log(success, data, self.submitted, self.reseller);
            self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            if (success) {
              if (data.success != 1) {
                if (data.form) {
                  Object.keys(data.form).forEach(function(key) {
                    if (data.form[key] != 0) {
                      self.error[key] = " Invalid value";
                      $("#a_"+key)[0].scrollIntoView();
                    }
                  });
                }
                if (data.success == -2) {
                  $("#a_email")[0].scrollIntoView();
                  self.error['email'] = self.res.login_err;
                } else if (data.success == -3) {
                  $("#a_email")[0].scrollIntoView();
                  self.error['email'] = self.res.login_err;
                }
                self.$forceUpdate();
              } else {
                if (data.locale) {
                  Vue.cookie.set('locale', data.locale);
                }
                if (data.custcode) {
                  Vue.cookie.set('custcode', data.custcode);
                }
                if (data.isactive == 0) {
                  self.isactive = data.isactive;
                  self.reseller = data;
                  self.$forceUpdate();
                } else {
                  self.$root.$emit('authed', self.reseller); 
                  return;
                }
              }
            }
            self.submitted = false;
            grecaptcha.reset();
        });
      } else {
        grecaptcha.reset();
        self.submitted = false;
        if (goto) {
          $("#a_"+goto)[0].scrollIntoView();
          goto = null;
        }
        var fd = utils.saveJSONToForm(this.reseller);
        //self.$emit('iposevent', 'doregister', this.reseller);
      }
      this.$forceUpdate();
    },
    removeErr: function(evt, name) {
      console.log(name);
      delete this.error[name];
      this.$forceUpdate();
    }
  },
  computed: {
    pageRoot: function() {
      return utils.getPageRoot();
    },
  },
  created: function() {
  },
  mounted: function() {
    this.initReCaptcha();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegLogin.vue